export default __webpack_public_path__ + "static/media/f_iframe.991826db.svg";